import { authAxios } from './authAxios';

/**
 * RTK Query baseQuery for authApi — always talks to the real backend via
 * authAxios, regardless of DEMO_MODE (unlike every other feature slice's
 * axiosBaseQuery, which routes to the mock server when DEMO_MODE is on).
 * Auth is the one resource area that's actually live on the real API.
 */
export const authBaseQuery =
  () =>
  async ({ url, method = 'GET', data, params, headers }) => {
    try {
      const result = await authAxios({ url, method, data, params, headers });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data ?? { status: false, message: err.message },
        },
      };
    }
  };

export default authBaseQuery;
